/* eslint-disable i18next/no-literal-string */
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { alpha } from '@mui/material/styles';
import { useTheme } from '@mui/material';
import { useAuth } from '@/hooks/useAuth';
// import { useTranslation } from 'react-i18next';
// import { useProfile } from '@/hooks/useProfile';
// import { fullName } from '@/util/util';

const PageHeader = () => {
  const theme = useTheme();
  const { userInfo } = useAuth();
  return (
    <Box
      data-testid="page-header"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        mb: 6,
      }}
    >
      <Typography
        variant="h2"
        component="h1"
        gutterBottom
        data-testid="page-header-title"
        sx={{
          fontWeight: 700,
          fontSize: { xs: '2.5rem', md: '3.5rem' },
          letterSpacing: '-0.025em',
          mb: 1,
          textAlign: 'center',
        }}
      >
        Hello, {userInfo?.given_name} {userInfo?.family_name} !
      </Typography>
      <Typography
        variant="h6"
        data-testid="page-header-subtitle"
        sx={{
          mb: 4,
          color: alpha(theme.palette.text.primary, 0.7),
          fontWeight: 400,
          maxWidth: '600px',
          textAlign: 'center',
          fontSize: '1.1rem',
        }}
      >
        Search for the staff member you would like to view data for in My eXp.
      </Typography>
    </Box>
  );
};

export default PageHeader;
